var keycloak;
function checkLogin(returnUrl, isAuthenticated) {
    
    if (!isAuthenticated) {
        keycloak = new Keycloak("/keycloak.json");
        keycloak.init({
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
        }).then(function (authenticated) {
            if (authenticated) {
                $(location).attr("href", "/ingresar-sso?returnUrl=" + returnUrl);
            }
        }).catch(function () {
        });
    }
    
}